import React from 'react';

const WindowSizeContext = React.createContext<{ width: number; height: number }>({ width: 800, height: 800 });

export default WindowSizeContext;
